<template>
  <div class="no-page-wrap">
    <p class="head">Oops!</p>
    <p class="tip">You are lost</p>
    <van-image width="100%" :src="require('../assets/images/noPage.jpg')" />
    <router-link class="go-home" to="/">Back to Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'noPage'
}
</script>

<style scoped lang="scss">
.no-page-wrap {
  height: 100vh;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  padding: 20px 36px;
  background-color: #fff;

  .head {
    font-size: 30px;
    font-weight: 600;
    color: #000;
    width: 100%;
    margin-top: 100px;
  }

  .tip {
    width: 100%;
    color: #000;
    margin: 30px 0 60px;
  }

  .go-home {
    width: 100%;
    height: 52px;
    line-height: 52px;
    margin-top: 100px;
    text-align: center;
    background-color: #000;
    color: #fff;
  }
}
</style>
